import React from 'react';
import Thing from './Thing';
import style from './Things.module.css';
import thingService from '../../services/thingService';

function ThingsList({
  thing,
  things,
  onAddDevice,
  onRemoveDevice,
  setThings,
  actionCallback,
  userId,
  product,
  addSuccessMessage,
  addErrorMessage,
  productType,
  thingTypeName
}) {
  if (!thing) {
    return (
      <div className={style.no_things}>
        No <strong>{thingTypeName}</strong> found
      </div>
    );
  }

  return (
    <Thing
      thing={thing}
      onAddDevice={onAddDevice}
      onRemoveDevice={onRemoveDevice}
      onRemoveThing={async ({ thingId, name }) => {
        try {
          await thingService.deleteThing({
            thingId,
            userId,
            syncUpAppName: product
          });
          setThings(await actionCallback());
          addSuccessMessage({ message: `${name} was successfully deleted.` });
        } catch (error) {
          addErrorMessage({ error });
        }
      }}
      productType={productType}
    />
  );
}

export default ThingsList;
